import {PrismicNextImage} from '@prismicio/next/pages'
import type {EventDocument} from 'prismicio-types'
import {memo, useContext} from 'react'
import {Icon} from 'src/common/Icon'
import {DialogContext} from 'src/context/DialogContext'
import {getBackgroundImage} from '../../helpers'

export const VideoPreview = memo(({data}: {data: EventDocument['data']}) => {
  const context = useContext(DialogContext)

  const handlePlayClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()

    if (context) {
      context.setIsDialogOpen(true)
    }
  }

  const backgroundImage = getBackgroundImage(data)

  return (
    <button
      type="button"
      className="relative w-full cursor-pointer self-start overflow-hidden rounded-[4px] border-0 bg-transparent p-0 lg:flex-1"
      style={{aspectRatio: '16/9'}}
      onClick={handlePlayClick}
    >
      {backgroundImage && (
        <PrismicNextImage
          field={backgroundImage}
          className="size-full object-cover blur-[8px]"
          priority
          sizes="(max-width: 768px) 100vw, (max-width: 1024px) 100vw, 800px"
        />
      )}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex size-20 items-center justify-center rounded-full bg-green-neon backdrop-blur-[9.8px] transition-transform hover:scale-110">
          <Icon name="play" className="h-[34px] w-[34px] text-moss-black" />
        </div>
      </div>
    </button>
  )
})

VideoPreview.displayName = 'VideoPreview'
